import React from 'react';

const Mark = ({ size = 30 }) => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' width={size} height={size} className='flex-shrink-0' aria-hidden='true'>
    <g transform='translate(3.4 1.3)'>
      <g transform='translate(4 -2) scale(1.2)'>
        <path
          d='M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z'
          fill='#3D6B57'
        />
      </g>
      <g transform='translate(0 2) scale(0.9)'>
        <g fill='none' stroke='#8BB89A' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
          <path d='M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z' />
          <path d='M4 13h4' />
        </g>
      </g>
      <g
        transform='translate(20.4 7.8) scale(-0.5,0.5) rotate(-60)'
        fill='none'
        stroke='#8BB89A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'>
        <path d='M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z' />
        <path d='M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12' />
      </g>
    </g>
  </svg>
);

/**
 * Current CYF lockup from compareyourfootprint.com (leaf mark + CompareYourFootprint).
 * @param {{ variant?: 'onLight' | 'onDark', size?: 'header' | 'login' }} props
 */
const CyfLockup = ({ variant = 'onLight', size = 'header' }) => {
  const onDark = variant === 'onDark';
  const text = onDark ? 'text-[#F5F0E8]' : 'text-[#1C2B26]';
  const your = onDark ? 'text-[#8BB89A]' : 'text-[#3D6B57]';
  const typeSize = size === 'login' ? 'text-[28px] md:text-[34px]' : 'text-[13px]';
  const gap = size === 'login' ? 'gap-3' : 'gap-1.5';
  const mark = size === 'login' ? 36 : 24;

  return (
    <span className={`inline-flex items-center ${gap} ${text}`} aria-label='Compare Your Footprint'>
      <Mark size={mark} />
      <span
        className={`whitespace-nowrap ${typeSize} leading-none ${text}`}
        style={{ fontFamily: "'DM Serif Display', Georgia, serif", fontWeight: 400 }}
        aria-hidden='true'>
        Compare<span className={your}>Your</span>Footprint
      </span>
    </span>
  );
};

export default CyfLockup;
